module.exports = __webpack_public_path__ + "static/media/june-youtube.fbba6a6a.jpg";